import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  "class": "breadcrumb-tabs mb-6"
};
var _hoisted_2 = {
  "class": "w-full flex justify-between items-center"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm font-bold text-ftext"
}, " Research Data ", -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm font-bold text-ftext"
}, " Data Breakup ", -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  "class": "w-1/3 bg-indigo-800 tabWidth p-2 px-4",
  as: "button"
}, [/*#__PURE__*/_createElementVNode("span", {
  "class": "text-sm font-bold text-white"
}, " Lead Conversions ")], -1);
var _hoisted_6 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-2 px-6 w-full"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Solution")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4"
}), /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Tenant")])], -1);
var _hoisted_8 = {
  "class": "px-2"
};
var _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-2"
}, [/*#__PURE__*/_createElementVNode("p", {
  "class": "w-full text-center"
}, "OR")], -1);
var _hoisted_10 = {
  "class": "px-2"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Industry")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Revenue")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Minimum Contacts")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Minimum Emails")])], -1);
var _hoisted_12 = {
  "class": "px-2 pb-4"
};
var _hoisted_13 = {
  "class": "px-2 pb-4"
};
var _hoisted_14 = {
  "class": "px-2 pb-4"
};
var _hoisted_15 = {
  "class": "px-2 pb-4"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Minimum Leads")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-6"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Maximum Leads")])], -1);
var _hoisted_17 = {
  "class": "px-2 pb-4"
};
var _hoisted_18 = {
  "class": "px-2 pb-4"
};
var _hoisted_19 = {
  "class": "px-2 py-4"
};
var _hoisted_20 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-2 px-6 w-full"
};
var _hoisted_21 = {
  "class": "w-full"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-2 w-1/3"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "w-full block text-gray-700 font-bold"
}, "Total combinations")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-2 w-1/3"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "w-full block text-gray-700 font-bold"
}, "Aleast one lead conversion")]), /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-2 w-1/3"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "w-full block text-gray-700 font-bold"
}, "Zero lead conversion")])], -1);
var _hoisted_23 = {
  "class": "px-6 py-2"
};
var _hoisted_24 = {
  "class": "block text-gray-700 font-bold"
};
var _hoisted_25 = {
  "class": "px-6 py-2"
};
var _hoisted_26 = {
  "class": "block text-gray-700 font-bold"
};
var _hoisted_27 = {
  "class": "px-6 py-2"
};
var _hoisted_28 = {
  "class": "block text-gray-700 font-bold"
};
var _hoisted_29 = {
  "class": "px-6 py-2"
};
var _hoisted_30 = {
  "class": "block text-gray-700 font-bold"
};
var _hoisted_31 = {
  "class": "px-6 py-2"
};
var _hoisted_32 = {
  "class": "block text-gray-700 font-bold"
};
var _hoisted_33 = {
  "class": "px-6 py-2"
};
var _hoisted_34 = {
  "class": "block text-gray-700 font-bold"
};
var _hoisted_35 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Link = _resolveComponent("Link");
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Link, {
    href: "/tenant/report",
    "class": "w-1/3 bg-white tabWidth p-2 px-4",
    as: "button"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_3];
    }),
    _: 1
  }), _createVNode(_component_Link, {
    href: "/tenant/parameter",
    "class": "w-1/3 bg-white tabWidth p-2 px-4",
    as: "button"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  }), _hoisted_5])]), _createElementVNode("div", null, [_createVNode(_component_Head, {
    title: "Advanced Data"
  }), _createElementVNode("div", _hoisted_6, [_createElementVNode("table", null, [_hoisted_7, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_8, [_createVNode(_component_el_select, {
    modelValue: $data.form.solution,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.solution = $event;
    }),
    filterable: "",
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $options.resetSearch('TENANT');
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.solutions, function (s) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: s.solution,
          label: s.solution
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _hoisted_9, _createElementVNode("td", _hoisted_10, [_createVNode(_component_el_select, {
    modelValue: $data.form.tenant_id,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.form.tenant_id = $event;
    }),
    multiple: "",
    filterable: "",
    onChange: _cache[3] || (_cache[3] = function ($event) {
      return $options.resetSearch('SOLUTION');
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tenants, function (t) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: t.tenant_id,
          label: t.tenant_id
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _hoisted_11, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_12, [_createVNode(_component_el_select, {
    modelValue: $data.form.industry,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.form.industry = $event;
    }),
    multiple: "",
    filterable: "",
    onChange: _cache[5] || (_cache[5] = function ($event) {
      return $data.resetPaginate = true;
    })
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.industries, function (i) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: i.sub_industry,
          label: i.sub_industry
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_13, [_createVNode(_component_el_select, {
    modelValue: $data.form.revenue,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
      return $data.form.revenue = $event;
    }),
    multiple: "",
    filterable: "",
    onChange: _cache[7] || (_cache[7] = function ($event) {
      return $data.resetPaginate = true;
    })
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        value: "< 1M",
        label: "< 1M"
      }), _createVNode(_component_el_option, {
        value: "1M TO 10M",
        label: "1M TO 10M"
      }), _createVNode(_component_el_option, {
        value: "10M TO 100M",
        label: "10M TO 100M"
      }), _createVNode(_component_el_option, {
        value: "100M TO 250M",
        label: "100M TO 250M"
      }), _createVNode(_component_el_option, {
        value: "250M TO 500M",
        label: "250M TO 500M"
      }), _createVNode(_component_el_option, {
        value: "500M TO 1B",
        label: "500M TO 1B"
      }), _createVNode(_component_el_option, {
        value: "> 1B",
        label: "> 1B"
      })];
    }),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_14, [_createVNode(_component_el_input, {
    modelValue: $data.form.contact,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) {
      return $data.form.contact = $event;
    }),
    placeholder: "Please input",
    type: "number",
    onChange: _cache[9] || (_cache[9] = function ($event) {
      return $data.resetPaginate = true;
    })
  }, null, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_15, [_createVNode(_component_el_input, {
    modelValue: $data.form.email_count,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
      return $data.form.email_count = $event;
    }),
    placeholder: "Please input",
    type: "number",
    onChange: _cache[11] || (_cache[11] = function ($event) {
      return $data.resetPaginate = true;
    })
  }, null, 8, ["modelValue"])])]), _hoisted_16, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_17, [_createVNode(_component_el_input, {
    modelValue: $data.form.lead_count,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
      return $data.form.lead_count = $event;
    }),
    placeholder: "Please input",
    type: "number",
    onChange: _cache[13] || (_cache[13] = function ($event) {
      return $data.resetPaginate = true;
    })
  }, null, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_18, [_createVNode(_component_el_input, {
    modelValue: $data.form.max_lead_count,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) {
      return $data.form.max_lead_count = $event;
    }),
    placeholder: "Please input",
    type: "number",
    onChange: _cache[15] || (_cache[15] = function ($event) {
      return $data.resetPaginate = true;
    })
  }, null, 8, ["modelValue"])])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_19, [_createElementVNode("button", {
    "class": "ml-3 text-white text-sm bg-indigo-800 px-6 py-2 rounded-md",
    type: "button",
    onClick: _cache[16] || (_cache[16] = function ($event) {
      return $options.resetSearch('ALL');
    })
  }, "Reset"), _createElementVNode("button", {
    "class": "ml-3 text-white text-sm bg-indigo-800 px-6 py-2 rounded-md",
    type: "button",
    onClick: _cache[17] || (_cache[17] = function () {
      return $options.getParameterData && $options.getParameterData.apply($options, arguments);
    })
  }, "Submit")])])])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("table", _hoisted_21, [_hoisted_22, _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_23, [_createElementVNode("label", _hoisted_24, _toDisplayString($data.countData.total), 1)]), _createElementVNode("td", _hoisted_25, [_createElementVNode("label", _hoisted_26, _toDisplayString($data.countData.lead), 1)]), _createElementVNode("td", _hoisted_27, [_createElementVNode("label", _hoisted_28, _toDisplayString($data.countData.no_lead), 1)])]), _createElementVNode("tr", null, [_createElementVNode("td", _hoisted_29, [_createElementVNode("label", _hoisted_30, "(Contacts: " + _toDisplayString($data.countData.total_contacts) + ")", 1)]), _createElementVNode("td", _hoisted_31, [_createElementVNode("label", _hoisted_32, "(Contacts: " + _toDisplayString($data.countData.lead_contacts) + ")", 1)]), _createElementVNode("td", _hoisted_33, [_createElementVNode("label", _hoisted_34, "(Contacts: " + _toDisplayString($data.countData.no_lead_contacts) + ")", 1)])])])]), _createElementVNode("div", _hoisted_35, [_createVNode(_component_el_table, {
    data: $data.solutionData,
    style: {
      "width": "100%"
    },
    sortable: "custom",
    onSortChange: $options.sortChange
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "sub_industry",
        label: "Industry",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "revenue_bucket",
        label: "Revenue",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "department",
        label: "Department",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "title",
        label: "Title",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "contact_count",
        label: "Unique Contacts(A)",
        width: "180",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "email_sent",
        label: "Email Sent",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "lead_count",
        label: "Leads(B)",
        sortable: ""
      }), _createVNode(_component_el_table_column, {
        prop: "lead_percent",
        label: "Lead Conversion(B/A)%",
        width: "180",
        sortable: ""
      })];
    }),
    _: 1
  }, 8, ["data", "onSortChange"]), _createVNode(_component_el_pagination, {
    background: "",
    layout: "prev, pager, next",
    total: $data.countData.totalRows,
    "class": "el-pagination is-background w-full justify-center py-4",
    onCurrentChange: $options.pageChange,
    "current-page": $data.form.currentPage
  }, null, 8, ["total", "onCurrentChange", "current-page"])])])], 64);
}